var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M99.9,130.7h63.7v-5.5H99.9l21.4-21.4l-3.5-3.5L90.2,128h0l0,0l0.3,0.2l27.4,27.4l3.5-3.5L99.9,130.7z M10,128C10,62.8,62.8,10,128,10c65.2,0,118,52.8,118,118c0,65.2-52.8,118-118,118C62.8,246,10,193.2,10,128z M240.5,128c0-62.1-50.4-112.5-112.5-112.5C65.9,15.5,15.5,65.9,15.5,128c0,62.1,50.4,112.5,112.5,112.5C190.1,240.5,240.5,190.1,240.5,128z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.1e93868edc99138d0b8034b81f423e20.svg";
export { ForwardRef as ReactComponent };